import { render, staticRenderFns } from "./discussion_jump_to_next_button.vue?vue&type=template&id=4c65865c&"
import script from "./discussion_jump_to_next_button.vue?vue&type=script&lang=js&"
export * from "./discussion_jump_to_next_button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports